import React from "react"
import  {MainCP}  from "../../Components/gobierno/MainCP"

const ViewGobierno: React.FC = () => <MainCP/>
export default ViewGobierno


